<div
  class="progress-cell"
  [class.row]="isRow()"
  [attr.aria-label]="'Progress ' + done() + ' of ' + total()"
>
  @if (showLabel()) {
    <span class="progress-cell-label">{{ done() }}/{{ total() }}</span>
  }

  <div class="progress-cell-track" aria-hidden="true">
    <div class="progress-cell-bar" [style.width.%]="percentage()"></div>
  </div>
</div>
